import { render, staticRenderFns } from "./BuildingCardSmall.vue?vue&type=template&id=0c229340&"
import script from "./BuildingCardSmall.vue?vue&type=script&lang=js&"
export * from "./BuildingCardSmall.vue?vue&type=script&lang=js&"
import style0 from "./BuildingCardSmall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports